<template>
  <div>
    <h4 :id="name ? name : false">
      {{ label }}
      <span v-if="fieldRequired">(required)</span>
    </h4>
    <doe-paragraph v-if="description" :description="description" />
  </div>
</template>

<script>
import DoeParagraph from "@/components/typography/Paragraph";

export default {
  name: "DoeFieldDateHeading",
  props: {
    name: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false
    },
    fieldRequired: {
      type: Boolean,
      default: false
    },
    description: {
      type: [Array, String],
      required: false
    },
    weight: {
      type: String,
      default: "semibold",
      validator: value => {
        return ["semibold", "light"].indexOf(value) !== -1;
      }
    }
  },
  components: {
    DoeParagraph
  }
};
</script>

<style lang="scss" scoped>
h4 {
  @apply block font-light font-sans leading-snug mb-1 subpixel-antialiased text-xl text-black w-full;
}
h4.light {
  @apply font-light;
}
@screen lg {
  h4 {
    @apply leading-snug text-xl;
  }
}
</style>
